/**
 * Centralized environment configuration
 * Handles environment-specific settings for different services
 */

import {
  isPreviewDeployment,
  isProductionDeployment,
  getDeploymentUrl
} from '@/lib/utils/vercel-env';

/**
 * Supabase configuration based on environment
 */
export interface SupabaseConfig {
  url: string;
  anonKey: string;
  serviceRoleKey?: string;
}

/**
 * Get Supabase configuration
 * Uses the environment variables as configured in each Vercel environment
 * (preview deployments should have dev Supabase URL/keys configured)
 */
export function getSupabaseConfig(): SupabaseConfig {
  if (
    !process.env.NEXT_PUBLIC_SUPABASE_URL ||
    !process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY
  ) {
    throw new Error('Missing required Supabase environment variables');
  }

  // Log which environment is being used
  if (isPreviewDeployment()) {
    console.log(
      `Preview deployment using Supabase URL: ${process.env.NEXT_PUBLIC_SUPABASE_URL}`
    );
  }

  return {
    url: process.env.NEXT_PUBLIC_SUPABASE_URL,
    anonKey: process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY,
    serviceRoleKey:
      process.env.SUPABASE_SERVICE_ROLE_KEY ||
      process.env.SUPABASE_SERVICE_ROLE_KEY
  };
}

/**
 * Log current environment configuration (for debugging)
 */
export function logEnvironmentConfig() {
  if (isPreviewDeployment() || process.env.NODE_ENV === 'development') {
    const config = {
      environment: isProductionDeployment()
        ? 'production'
        : isPreviewDeployment()
          ? 'preview'
          : 'development',
      deploymentUrl: getDeploymentUrl(),
      supabaseUrl: getSupabaseConfig().url
    };

    console.log('Environment Configuration:', config);
  }
}
